// extracted by mini-css-extract-plugin
export default {"container":"CommentBox__container___CIbR6"};